var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "farm-area" },
    [
      _c("WindowModal", {
        attrs: { title: _vm.modalTitle, type: "Global" },
        scopedSlots: _vm._u([
          {
            key: "modal-content",
            fn: function () {
              return [
                _vm.currentFarm !== null
                  ? _c("FarmAsset", {
                      ref: "farmAsset",
                      attrs: {
                        farm: _vm.currentFarm,
                        action: _vm.actionPicked,
                        transaction: _vm.transaction,
                      },
                      on: {
                        deposit: _vm.depositTokens,
                        withdraw: _vm.withdrawTokens,
                        initConfirmState: function ($event) {
                          return _vm.changeModalTitle("init")
                        },
                        initLoading: function ($event) {
                          return _vm.changeModalTitle("loading")
                        },
                        initSuccess: function ($event) {
                          return _vm.changeModalTitle("success")
                        },
                        initError: function ($event) {
                          return _vm.changeModalTitle("error")
                        },
                        closeGlobalModal: _vm.closeModal,
                      },
                    })
                  : _vm._e(),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _vm._v(" "),
      _c("div", { staticClass: "farm-box" }, [
        _c("div", { staticClass: "text-area" }, [
          _c("h1", [
            _vm._v("\n        " + _vm._s(_vm.$t("farm.farms")) + "\n      "),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "desc" }, [
            _vm._v(
              "\n        " + _vm._s(_vm.$t("farm.subheader1")) + "\n      "
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "image-area" }, [
          _c("div", { staticClass: "picture" }, [
            _c(
              "picture",
              [
                _c("source", {
                  attrs: {
                    srcset: "/img/new/floatie.webp",
                    type: "image/webp",
                  },
                }),
                _vm._v(" "),
                _c("nuxt-img", {
                  attrs: {
                    fit: "inside",
                    width: "2767",
                    sizes: "sm:250px md:300px lg:400px xl:500px xxl:560px",
                    src: "/img/new/floatie.png",
                    alt: "Farm $FLOATIE and harvest coin rewards on Defi Pool Finance",
                    title: "Farm $FLOATIE",
                  },
                }),
              ],
              1
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "cyan-cloud" }, [_c("CloudCyanStakeLeft")], 1),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "cyan-cloud2" },
          [_c("CloudCyanStakeRight")],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "filter-row" }, [
        _c("div", { staticClass: "start-area" }, [
          _c(
            "div",
            { staticClass: "switch-area" },
            [
              _c("Switcher", {
                attrs: { label: _vm.$t("stake.staked_only") },
                on: { select: _vm.changeStakedOnly },
                model: {
                  value: _vm.filter.stakedOnly,
                  callback: function ($$v) {
                    _vm.$set(_vm.filter, "stakedOnly", $$v)
                  },
                  expression: "filter.stakedOnly",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "status-area" }, [
            _c(
              "button",
              {
                class: {
                  "btn-status": true,
                  active: _vm.filter.status === "live",
                },
                attrs: { type: "button" },
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.setStatus("live")
                  },
                },
              },
              [
                _vm._v(
                  "\n          " + _vm._s(_vm.$t("stake.live")) + "\n        "
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                class: {
                  "btn-status": true,
                  active: _vm.filter.status === "finished",
                },
                attrs: { type: "button" },
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.setStatus("finished")
                  },
                },
              },
              [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.$t("stake.finished")) +
                    "\n        "
                ),
              ]
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "end-area" }, [
          _c(
            "div",
            { staticClass: "sort-area" },
            [
              _c("label", { attrs: { for: "sortList" } }, [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.$t("common.sort_by")) +
                    "\n        "
                ),
              ]),
              _vm._v(" "),
              _c("Select", {
                attrs: { options: _vm.filterOptions },
                model: {
                  value: _vm.filter.orderField,
                  callback: function ($$v) {
                    _vm.$set(_vm.filter, "orderField", $$v)
                  },
                  expression: "filter.orderField",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "search-area" }, [
            _c(
              "div",
              { staticClass: "search-input" },
              [
                _c("Search"),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.filter.search,
                      expression: "filter.search",
                    },
                  ],
                  attrs: {
                    type: "text",
                    сlass: "input",
                    placeholder: _vm.$t("common.search") + "...",
                  },
                  domProps: { value: _vm.filter.search },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(_vm.filter, "search", $event.target.value)
                    },
                  },
                }),
              ],
              1
            ),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _vm.farms.length > 0 && !_vm.farmsLoading
        ? _c(
            "div",
            { staticClass: "farms-area" },
            _vm._l(_vm.farms, function (farm, index) {
              return _c("div", { key: index, staticClass: "farm-item" }, [
                _c(
                  "div",
                  {
                    ref: "farmHeader" + index,
                    refInFor: true,
                    class: { "farm-header": true, active: farm.opened },
                    on: {
                      click: function ($event) {
                        return _vm.toggleAccordion(index)
                      },
                    },
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "logo" },
                      [
                        _c(
                          "div",
                          { staticClass: "forwards" },
                          [_c("ArrowBack")],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "backwards" },
                          [_c("ArrowBack")],
                          1
                        ),
                        _vm._v(" "),
                        _c("nuxt-img", {
                          staticClass: "first-token",
                          attrs: {
                            src:
                              farm.token_from.address !== _vm.$config.ZERO
                                ? _vm.$getImageByAddress(
                                    farm.token_from.address
                                  )
                                : _vm.$getImage(farm.token_from.logoURI),
                            alt: "$FLOATIE farm for earning auto multiple rewards",
                            title: "$FLOATIE farm",
                            quality: 80,
                            lazy: "",
                          },
                          on: {
                            error: function ($event) {
                              $event.target.src = require("~/static/img/default_token.svg")
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c("nuxt-img", {
                          staticClass: "second-token",
                          attrs: {
                            src:
                              farm.token_to.address !== _vm.$config.ZERO
                                ? _vm.$getImageByAddress(farm.token_to.address)
                                : _vm.$getImage(farm.token_to.logoURI),
                            alt: "$FLOATIE farm for earning auto multiple rewards",
                            title: "$FLOATIE farm",
                            quality: 80,
                            lazy: "",
                          },
                          on: {
                            error: function ($event) {
                              $event.target.src = require("~/static/img/default_token.svg")
                            },
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "header-area" }, [
                      _c("p", { staticClass: "desc" }, [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              farm.token_from.symbol +
                                " / " +
                                farm.token_to.symbol
                            ) +
                            "\n          "
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "core" }, [
                      _c(
                        "div",
                        { staticClass: "core-item" },
                        [
                          _c("Verified"),
                          _vm._v(" "),
                          _c("p", [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.$t("farm.core")) +
                                "\n            "
                            ),
                          ]),
                        ],
                        1
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "regular-item earned no-mobile-border" },
                      [
                        _c(
                          "div",
                          { staticClass: "icon-area" },
                          [_c("Coins")],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "value-area" }, [
                          _c("p", { staticClass: "desc" }, [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.$t("farm.earned")) +
                                "\n            "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("p", { staticClass: "value" }, [
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  _vm.$priceFormat(farm.earned, 2, ".", ",")
                                ) +
                                "\n            "
                            ),
                          ]),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "regular-item apr-area" }, [
                      _c(
                        "div",
                        { staticClass: "icon-area" },
                        [_c("ChartApr")],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "value-area" }, [
                        _c("p", { staticClass: "desc" }, [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.$t("farm.apr")) +
                              "\n            "
                          ),
                        ]),
                        _vm._v(" "),
                        farm.apr !== -1
                          ? _c("p", { staticClass: "value" }, [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm.$priceFormat(farm.apr, 2, ".", ",") +
                                      "%"
                                  ) +
                                  "\n            "
                              ),
                            ])
                          : _c(
                              "div",
                              { staticClass: "value" },
                              [
                                _c("Skeleton", {
                                  attrs: { width: "60px", height: "16px" },
                                }),
                              ],
                              1
                            ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "regular-item liquidity-area" }, [
                      _c("div", { staticClass: "icon-area" }, [_c("Money")], 1),
                      _vm._v(" "),
                      _c("div", { staticClass: "value-area" }, [
                        _c("p", { staticClass: "desc" }, [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.$t("farm.liquidity")) +
                              "\n            "
                          ),
                        ]),
                        _vm._v(" "),
                        farm.liquidity !== -1
                          ? _c("p", { staticClass: "value" }, [
                              _vm._v(
                                "\n              $" +
                                  _vm._s(
                                    _vm.$priceFormat(
                                      farm.liquidity,
                                      0,
                                      ".",
                                      ","
                                    )
                                  ) +
                                  "\n            "
                              ),
                            ])
                          : _c(
                              "div",
                              { staticClass: "value" },
                              [
                                _c("Skeleton", {
                                  attrs: { width: "60px", height: "16px" },
                                }),
                              ],
                              1
                            ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "regular-item multiplier-area" }, [
                      _c(
                        "div",
                        { staticClass: "icon-area" },
                        [_c("Rocket")],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "value-area" }, [
                        _c("p", { staticClass: "desc" }, [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.$t("farm.multiplier")) +
                              "\n            "
                          ),
                        ]),
                        _vm._v(" "),
                        farm.multiplier !== -1
                          ? _c("p", { staticClass: "value" }, [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm.$priceFormat(
                                      farm.multiplier,
                                      0,
                                      ".",
                                      ","
                                    )
                                  ) +
                                  " X\n            "
                              ),
                            ])
                          : _c(
                              "div",
                              { staticClass: "value" },
                              [
                                _c("Skeleton", {
                                  attrs: { width: "60px", height: "16px" },
                                }),
                              ],
                              1
                            ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "trigger-area" }, [
                      _c(
                        "p",
                        [
                          _c("span", { staticClass: "mobile-visible" }, [
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  !farm.opened
                                    ? _vm.$t("common.show")
                                    : _vm.$t("common.hide")
                                ) +
                                "\n            "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("ChevronDown"),
                        ],
                        1
                      ),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    ref: "farmDetails" + index,
                    refInFor: true,
                    class: { "farm-details": true, active: farm.opened },
                  },
                  [
                    _c("div", { staticClass: "details-area" }, [
                      _c("div", { staticClass: "numbers-area" }, [
                        _c("div", { staticClass: "input-area recent-profit" }, [
                          _c("div", { staticClass: "info" }, [
                            _c("div", { staticClass: "h6" }, [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(
                                    farm.token_from.symbol +
                                      " " +
                                      _vm.$t("farm.earned")
                                  ) +
                                  "\n                "
                              ),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "h3" }, [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(
                                    _vm.$formatCryptoAmount(farm.earned, 12)
                                  ) +
                                  "\n                  "
                              ),
                              _c("span", { staticClass: "currency" }, [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(farm.token_from.symbol) +
                                    "\n                  "
                                ),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "h5" }, [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(_vm.convertToUsd(farm.earned)) +
                                  "\n                  "
                              ),
                              _c("span", { staticClass: "currency" }, [
                                _vm._v(
                                  "\n                    USD\n                  "
                                ),
                              ]),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "action" }, [
                            _c(
                              "button",
                              {
                                class: {
                                  "btn cyan": true,
                                  disabled:
                                    _vm.farmLoading || farm.earned === 0,
                                },
                                attrs: { type: "button" },
                                on: {
                                  click: function ($event) {
                                    return _vm.harvestTokens(farm)
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(_vm.$t("stake.harvest")) +
                                    "\n                "
                                ),
                              ]
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        farm.deposited === 0
                          ? _c(
                              "div",
                              { staticClass: "input-area farm-actions" },
                              [
                                _c("div", { staticClass: "info" }, [
                                  _c("div", { staticClass: "h6" }, [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(_vm.$t("farm.start_farming")) +
                                        "\n                "
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.farmAmount,
                                        expression: "farmAmount",
                                      },
                                    ],
                                    attrs: {
                                      type: "number",
                                      step: "0.00001",
                                      lang: "en",
                                      min: "0",
                                      placeholder: "0...",
                                    },
                                    domProps: { value: _vm.farmAmount },
                                    on: {
                                      input: function ($event) {
                                        if ($event.target.composing) return
                                        _vm.farmAmount = $event.target.value
                                      },
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "h5" }, [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(
                                          _vm.$formatCryptoAmount(
                                            farm.balance,
                                            8
                                          ) +
                                            " " +
                                            _vm.$t("farm.lp_tokens") +
                                            " " +
                                            _vm.$t("farm.available")
                                        ) +
                                        "\n                "
                                    ),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "action" }, [
                                  _c(
                                    "button",
                                    {
                                      class: {
                                        "btn cyan": true,
                                        disabled:
                                          _vm.farmLoading ||
                                          _vm.farmAmount === null ||
                                          _vm.farmAmount === 0,
                                      },
                                      attrs: { type: "button" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.depositTokens(farm)
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(_vm.$t("farm.farm")) +
                                          "\n                "
                                      ),
                                    ]
                                  ),
                                ]),
                              ]
                            )
                          : _c(
                              "div",
                              { staticClass: "input-area farm-actions" },
                              [
                                _c("div", { staticClass: "info" }, [
                                  _c("div", { staticClass: "h6" }, [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(
                                          farm.token_from.symbol +
                                            "-" +
                                            farm.token_to.symbol +
                                            " LP " +
                                            _vm.$t("farm.staked")
                                        ) +
                                        "\n                "
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "h3" }, [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(
                                          _vm.$formatCryptoAmount(
                                            farm.deposited,
                                            8
                                          )
                                        ) +
                                        "\n                  "
                                    ),
                                    _c("span", { staticClass: "currency" }, [
                                      _vm._v(
                                        "\n                    LPs\n                  "
                                      ),
                                    ]),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "h5" }, [
                                    _vm._v(
                                      "\n                  ~" +
                                        _vm._s(_vm.convertLPToUsd(farm)) +
                                        "\n                  "
                                    ),
                                    _c("span", { staticClass: "currency" }, [
                                      _vm._v(
                                        "\n                    USD\n                  "
                                      ),
                                    ]),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "h5" }, [
                                    _vm._v(
                                      "\n                  ~" +
                                        _vm._s(
                                          _vm.getFarmFirstTokenAmount(farm) +
                                            " " +
                                            farm.token_from.symbol
                                        ) +
                                        " • \n                  ~" +
                                        _vm._s(
                                          _vm.getFarmSecondTokenAmount(farm) +
                                            " " +
                                            farm.token_to.symbol
                                        ) +
                                        "\n                "
                                    ),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "action" }, [
                                  _c(
                                    "button",
                                    {
                                      staticClass: "btn cyan",
                                      attrs: { type: "button" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.toggleModal(
                                            farm,
                                            "withdraw"
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(
                                            _vm.$t("farm.withdraw_action")
                                          ) +
                                          "\n                "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "button",
                                    {
                                      staticClass: "btn cyan",
                                      attrs: { type: "button" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.toggleModal(
                                            farm,
                                            "deposit"
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(
                                            _vm.$t("farm.deposit_action")
                                          ) +
                                          "\n                "
                                      ),
                                    ]
                                  ),
                                ]),
                              ]
                            ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "help-area" }, [
                      _c("div", { staticClass: "help-list" }, [
                        _c("div", { staticClass: "item" }, [
                          _c(
                            "p",
                            {
                              staticClass: "bottom-link",
                              on: {
                                click: function ($event) {
                                  return _vm.generateAddLiquidityLink(farm)
                                },
                              },
                            },
                            [
                              _c("ChevronRight"),
                              _vm._v(
                                "\n                " +
                                  _vm._s(
                                    _vm.$t("farm.get") +
                                      " " +
                                      farm.token_from.symbol +
                                      "-" +
                                      farm.token_to.symbol +
                                      " LP"
                                  ) +
                                  "\n              "
                              ),
                            ],
                            1
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "item" },
                          [
                            _c(
                              "nuxt-link",
                              {
                                staticClass: "bottom-link",
                                attrs: { to: _vm.localePath("/docs") },
                              },
                              [
                                _c("ChevronRight"),
                                _vm._v(
                                  "\n                " +
                                    _vm._s(_vm.$t("stake.view_tutorial")) +
                                    "\n              "
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "item" }, [
                          _c(
                            "a",
                            {
                              staticClass: "bottom-link",
                              attrs: {
                                href: _vm.generateScanLink(farm.lpAddress),
                                rel: "nofollow noopener noreferrer",
                                target: "_blank",
                              },
                            },
                            [
                              _c("ChevronRight"),
                              _vm._v(
                                "\n                " +
                                  _vm._s(_vm.$t("stake.view_contract")) +
                                  "\n              "
                              ),
                            ],
                            1
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "item" },
                          [
                            _c(
                              "nuxt-link",
                              {
                                staticClass: "bottom-link",
                                attrs: {
                                  to: _vm.localePath(
                                    _vm.generateTokenInfoLink(farm.lpAddress)
                                  ),
                                  rel: "nofollow noopener noreferrer",
                                  target: "_blank",
                                },
                              },
                              [
                                _c("ChevronRight"),
                                _vm._v(
                                  "\n                " +
                                    _vm._s(_vm.$t("farm.pair_info")) +
                                    "\n              "
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "item" }, [
                          _c(
                            "p",
                            {
                              staticClass: "bottom-link",
                              on: {
                                click: function ($event) {
                                  return _vm.$addToMetamask(farm.lp)
                                },
                              },
                            },
                            [
                              _c("ChevronRight"),
                              _vm._v(
                                "\n                " +
                                  _vm._s(_vm.$t("common.add_to_metamask")) +
                                  "\n                "
                              ),
                              _c("MetamaskIcon"),
                            ],
                            1
                          ),
                        ]),
                      ]),
                    ]),
                  ]
                ),
              ])
            }),
            0
          )
        : _vm.farmsLoading
        ? _c(
            "div",
            { staticClass: "farms-area" },
            _vm._l(3, function (index) {
              return _c("div", { key: index, staticClass: "farm-item" }, [
                _c("div", { staticClass: "farm-header" }, [
                  _c(
                    "div",
                    { staticClass: "logo" },
                    [
                      _c("Skeleton", {
                        attrs: { width: "50px", height: "50px", circle: "" },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "header-area" },
                    [
                      _c("Skeleton", {
                        attrs: { width: "75px", height: "16px" },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "core" },
                    [
                      _c("Skeleton", {
                        attrs: { width: "85px", height: "32px" },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "regular-item earned no-mobile-border" },
                    [
                      _c(
                        "div",
                        { staticClass: "icon-area" },
                        [
                          _c("Skeleton", {
                            attrs: {
                              width: "21px",
                              height: "21px",
                              circle: "",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "value-area" },
                        [
                          _c("Skeleton", {
                            staticStyle: { "margin-bottom": "0.5rem" },
                            attrs: { width: "45px", height: "14px" },
                          }),
                          _vm._v(" "),
                          _c("Skeleton", {
                            attrs: { width: "35px", height: "16px" },
                          }),
                        ],
                        1
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "regular-item apr-area" }, [
                    _c(
                      "div",
                      { staticClass: "icon-area" },
                      [
                        _c("Skeleton", {
                          attrs: { width: "21px", height: "21px", circle: "" },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "value-area" },
                      [
                        _c("Skeleton", {
                          staticStyle: { "margin-bottom": "0.5rem" },
                          attrs: { width: "45px", height: "14px" },
                        }),
                        _vm._v(" "),
                        _c("Skeleton", {
                          attrs: { width: "35px", height: "16px" },
                        }),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "regular-item liquidity-area" }, [
                    _c(
                      "div",
                      { staticClass: "icon-area" },
                      [
                        _c("Skeleton", {
                          attrs: { width: "21px", height: "21px", circle: "" },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "value-area" },
                      [
                        _c("Skeleton", {
                          staticStyle: { "margin-bottom": "0.5rem" },
                          attrs: { width: "45px", height: "14px" },
                        }),
                        _vm._v(" "),
                        _c("Skeleton", {
                          attrs: { width: "35px", height: "16px" },
                        }),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "regular-item multiplier-area" }, [
                    _c(
                      "div",
                      { staticClass: "icon-area" },
                      [
                        _c("Skeleton", {
                          attrs: { width: "21px", height: "21px", circle: "" },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "value-area" },
                      [
                        _c("Skeleton", {
                          staticStyle: { "margin-bottom": "0.5rem" },
                          attrs: { width: "45px", height: "14px" },
                        }),
                        _vm._v(" "),
                        _c("Skeleton", {
                          attrs: { width: "35px", height: "16px" },
                        }),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "trigger-area" },
                    [
                      _c("Skeleton", {
                        attrs: { width: "70px", height: "16px" },
                      }),
                    ],
                    1
                  ),
                ]),
              ])
            }),
            0
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }